"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fluent_1 = __importDefault(require("./fluent"));
/** @internal */
const identity = (t) => t;
exports.identity = identity;
/** @internal */
const identityAsync = async (t) => t;
exports.identityAsync = identityAsync;
/** @internal */
const truth = () => true;
exports.truth = truth;
/** @internal */
const truthAsync = async () => true;
exports.truthAsync = truthAsync;
/** @internal */
const fluentGroup = (grp) => ({ ...grp, values: fluent_1.default(grp.values) });
exports.fluentGroup = fluentGroup;
/**
 * Generates a `count` long sequential integer interval starting from `fromInclusive`.
 *
 * * The interval starts at zero if `fromInclusive` is not specified.
 * * The interval ends in infinity if `count` is not specified.
 *
 * Examples:
 *
 * 1. `interval(5, 3)` generates an interval of `[5, 6, 7]`
 * 2. `interval(5)` generates an interval of `[5, 6, 7, ...]`
 * 3. `interval()` generates an interval of `[0, 1, 2, ...]`
 * 4. `fluent(interval(1)).take(10).forEach(console.log)` prints all numbers between 1 and 10 using [[fluent]].
 * @param fromInclusive Specifies the start of the interval. Defaults to zero.
 * @param count Specifies the length of the interval. The interval provides numbers indefinitely if omitted.
 * @returns The iterable of numbers in the interval.
 */
function* interval(fromInclusive, count) {
    const from = fromInclusive || 0;
    for (let offset = 0; count ? offset < count : true; ++offset) {
        yield from + offset;
    }
}
exports.interval = interval;
//# sourceMappingURL=utils.js.map